@if (hasNoRole() || messages().length) {
  <div class="m-lg !p-lg !gap-md overflow-y-auto bg-white" hlmCard>
    <p class="title-small-semibold">Informations importantes</p>
    <div class="w-2/5">
      @if (hasNoRole()) {
        <app-alerte
          title="Veuillez prendre contact avec votre manager"
          message="Il semblerait que vous n'ayez pas encore de droits pour utiliser l'application.
    Contactez votre manager de l’outil pour qu’il vous assigne les bons droits.
    Vous pouvez visualiser les différents livrables mais vous ne pourrez pas les modifier."
          type="informative"
        />
      } @else if (messages().length) {
        @for (message of messages() | trierPar: 'dateDebut'; track message.id; let last = $last) {
          <div>
            <h4 class="title-very-small-semibold">{{ message.titre }}</h4>
            <div [innerHtml]="message.contenu"></div>
          </div>
          @if (!last) {
            <hlm-separator />
          }
        }
      }
    </div>
    @if (hasNoRole()) {
      <div class="gap-lg text-components-content-neutral-secondary flex underline [&>a]:cursor-pointer">
        <a>Documentation de la Méthode</a>
        <a>Documentation Utilisateur de l'Outil</a>
      </div>
    }
  </div>
}
<app-visualisation-referentiel />

<!-- TODO à réafficher après le V1  -->
<app-offre-de-formation hidden />

@if (isAdmin()) {
  <app-administration />
}
